<template>
  <div>
    <v-snackbar
      content-class="centered"
      absolute
      top
      :timeout="3000"
      v-model="snackbar"
      >{{ snackbarText }}</v-snackbar
    >
    <v-container fluid>
      <v-row class="header-title-actions">
        <v-col cols="12" sm="6" md="6">
          <h1 class="page-title">{{ $t("zones.title") }}</h1>
        </v-col>

        <v-col class="align-end" cols="12" sm="6" md="6">
          <v-btn color="buttons" @click="showAddItemDialog" :loading="loading">
            <v-icon left> fas fa-plus </v-icon>
            {{ $t("zones.add") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <!-- <v-col cols="12" sm="12" md="12">
          <search />
        </v-col> -->

        <v-col cols="12" sm="12" md="12">
          <files-table
            @menuClick="handleMenuActions($event)"
            :items="zones"
            :showEdit="true"
            :showDelete="true"
            :loading="loading"
            :headers="headers"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      fullscreen
      transition="dialog-bottom-transition"
      v-if="addItemDialog"
      persistent
      v-model="addItemDialog"
      style="overflow: hidden !important"
    >
      <add-zone
        @success="handleSuccess"
        :originalItem="selectedItem"
        @cancel="addItemDialog = false"
      />
    </v-dialog>

    <v-dialog max-width="500px" v-if="deleteDialog" v-model="deleteDialog">
      <delete-item
        ref="deleteComponent"
        :name="selectedItem.name"
        @success="confirmDelete"
        @cancel="deleteDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import addZone from "./add-zone";
import filesTable from "@/components/files-table";
import deleteItem from "@/components/delete";
import { mapActions, mapState } from "vuex";

export default {
  name: "Zones",
  components: {
    addZone,
    filesTable,
    deleteItem,
  },
  data() {
    return {
      selectedItem: "",
      addItemDialog: "",
      deleteDialog: false,
      snackbarText: "",
      snackbar: false,
      loading: true,
      zones: [],
      headers: [
        {
          text: this.$t("headers.name"),
          value: "name",
          width: "150px",
        },
        {
          text: this.$t("headers.aspect_ratio"),
          value: "aspect",
          width: "200px",
        },
        {
          text: this.$t("headers.createdAt"),
          value: "createdAt",
          width: "200px",
        },
        {
          value: "options",
          sortable: false,
          align: "end",
        },
      ],
    };
  },

  computed: {
    ...mapState(["groupId"]),
  },

  methods: {
    ...mapActions(["cleanSearch"]),
    showAddItemDialog() {
      this.selectedItem = null;
      this.addItemDialog = true;
    },
    editZone(item) {
      this.selectedItem = item;
      this.addItemDialog = true;
    },
    showDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    handleMenuActions(payload) {
      switch (payload.action) {
        case "edit":
          this.editZone(payload.item);
          break;
        case "delete":
          this.showDeleteDialog(payload.item);
          break;
      }
    },
    handleSuccess() {
      this.snackbarText = this.selectedItem
        ? this.$t("zones.updated")
        : this.$t("zones.added");
      this.snackbar = true;
      this.addItemDialog = false;
    },

    async confirmDelete() {
      this.$refs.deleteComponent.loading = true;
      db.collection("zones")
        .doc(this.selectedItem[".key"])
        .delete()
        .then((response) => {
          this.snackbarText = this.$t("zones.deleted");
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
          this.deleteDialog = false;
        })
        .catch((error) => {
          this.snackbarText = this.$t("messages.unknown");
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
        });
    },
  },
  mounted() {
    this.cleanSearch();

    db.collection("zones")
      .where("groupId", "==", this.groupId)
      .onSnapshot((response) => {
        this.zones = [];
        response.forEach((item) => {
          let zone = item.data();
          zone[".key"] = item.id;
          this.zones.push(zone);
        });
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.v-dialog--fullscreen {
  overflow: hidden !important;
}
</style>